import React from 'react'
import {Link} from "react-router-dom";

export default function Footer() {
  return (
    <>
      <footer>
    <div className="container">
        <div className="row">
            <div className="col-md-4">
                <div className="footAbout">
                    <h4>About Us</h4>
                    <p>Unlock Destinations is a dynamic travel company dedicated to providing exceptional travel experiences to its customers. With a passion for exploration and a commitment to customer satisfaction, we strive to create memorable journeys that exceed expectations. Our mission is to inspire and enable people to explore the world by offering a diverse range of travel services that cater to various interests, preferences, and budgets.</p>
                </div>
            </div>

            <div className="col-6 col-md-4">
                <div className="quickLinks">
                    <h4>International</h4>
                    <ul>
                        <li><Link to="/">Dubai</Link></li>
                        <li><Link to="/">Bali</Link></li>
                        <li><Link to="/">Maldives</Link></li>
                        <li><Link to="/">Thailand</Link></li>
                    </ul>
                </div>
                <div className="quickLinks">
                    <h4>Domestic</h4>
                    <ul>
                        <li><Link to="/">Leh</Link></li>
                        <li><Link to="/">Kerela</Link></li>
                        <li><Link to="/">Rajasthan</Link></li>
                        <li><Link to="/">Ladakh</Link></li>
                    </ul>
                </div>
            </div>

            <div className="col-6 col-md-4">
                <div className="quickLinks">
                    <h4>Quick Links</h4>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/">About Us	</Link></li>
                        <li><Link to="/">Packages</Link></li>
                        <li><Link to="/">Featured</Link></li>
                        <li><Link to="/">Contact Us</Link></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>
    </>
  )
}
